// `isMaster`, `getMasterDomain`, `prepareLsPayloadData` and `getLSRequestPayloadData` moved to
// @rista/core/helpers/localServer. They are re-exported below, so this file's importers are
// unchanged; `getLSRequestPayloadData` is also IMPORTED because `isMasterOffline` and
// `getMasterInfo` below still call it.
//
// The rest of the file stays here on purpose: `isMasterOffline` needs `setOffline` from
// ./OfflineHelper, and lifting it would carry that cycle into core (ledger hazard 28).
import { exec, isElectron } from "utils/nativeHooks";
import { isOffline } from "facade/ServiceFacade";
import { setOffline } from "./OfflineHelper";
import { NW_APP_EVENT_ACTIONS, NW_APP_EVENT_KEYS } from "data/constants";
import { getLSRequestPayloadData } from "@rista/core/helpers/localServer";
import store from "../redux-store/index";
import { isEmpty } from "lodash";
import { getLocalStorage } from "utils";
import { DEVICEIDENTIFIER } from "utils/constants";

export {
  isMaster,
  getMasterDomain,
  prepareLsPayloadData,
  getLSRequestPayloadData,
} from "@rista/core/helpers/localServer";

export function callLocalServerDb() {

    return;
}

export function isBranchAvailable() {
    let businessData = store.getState().businessStore?.businessData;
    return (!!businessData?.branchId);
}


export function isSlave() {
    let catalogStore = store.getState()?.catalogStore;
    console.log(catalogStore);
    if (!!catalogStore?.posSettings) {
        let posSettings = catalogStore.posSettings || {},
            localServer = posSettings.localServer;
        if (localServer && !isEmpty(localServer.deviceIdentifier) && localServer.deviceIdentifier !== getLocalStorage(DEVICEIDENTIFIER)) {
            return true;
        }
    }
    return false;
}

export function callServer(path: string = "", msg: any = {}, callback: any) {
    let params, url, localServer = store.getState().catalogStore?.posSettings?.localServer;
    params = {
        deviceIdentifier: getLocalStorage(DEVICEIDENTIFIER),
        message: encodeURIComponent(JSON.stringify(msg))
    };

}



  
export function isMasterOffline(cb: any) {
  let message = {
      type: 'IS_OFFLINE',
      data: {},
    },
    d = getLSRequestPayloadData('misc', message);
  const callbackFunction = (res: any) => {
    cb(res);
    if (res && !isOffline() && isSlave()) {
      setOffline(true);
    } else if (isOffline() && isSlave() && !res) {
      setOffline(false);
    }
  }
  if (isElectron()) {
    (window as any).electronAPI.server.post(d)
      .then((response: any) => callbackFunction(response?.error ? null : response?.data))
      .catch(() => callbackFunction(null));
  } else {
    exec(NW_APP_EVENT_KEYS.server, NW_APP_EVENT_ACTIONS.server.post, d, { callbackFn: callbackFunction });
  }
}

export function getMasterIp() {
    let catalogStore = store.getState()?.catalogStore,
        posSettings = catalogStore.posSettings || {},
        localServer = posSettings.localServer;
    return (localServer?.address || "");
}

export function isLocalServerEnable() {
    let catalogStore = store.getState()?.catalogStore,
        posSettings = catalogStore.posSettings || {},
        localServer = posSettings.localServer || {};
    return (!!localServer?.address);
}

export function getMasterInfo(cb: any) {
  let message = {
      type: 'DEVICE_INFO',
      data: {},
    },
    d = getLSRequestPayloadData('misc', message);
  if (isElectron()) {
    (window as any).electronAPI.server.post(d)
      .then((response: any) => cb(response?.error ? null : response?.data))
      .catch(() => cb(null));
  } else {
    exec(NW_APP_EVENT_KEYS.server, NW_APP_EVENT_ACTIONS.server.post, d, { callbackFn: cb });
  }
  // store.dispatch(callLocalServerMaster(data));
}